import { RestUrl } from "../../common/cyan.types";

export class EcoaAccessTokenUrl {
  public static verifyEcoaAccessToken: RestUrl = ["POST", "/ecoa/access-token/verify"];
}
